// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAIDk8UXN_krXTi4H0mZXnQdH3ywxOEAao",
  authDomain: "voyceme-6c08b.firebaseapp.com",
  projectId: "voyceme-6c08b",
  storageBucket: "voyceme-6c08b.appspot.com",
  messagingSenderId: "727667948050",
  appId: "1:727667948050:web:1b071579d7fa6d5201b6cb",
  measurementId: "G-Q1R3N9JD8B"
};

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
let analytics;
if (app.name && typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics, app, logEvent }